export enum ContactRole {
  Unspeficied = 0,
  ContractManager = 13,
  Assessor = 21,
  ClientManager = 22,
  HoursAndExpensesReportManager = 23,
}
